import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IAssetsListState } from '../../../../interfaces/assets/IAssetsList';
import { AssetsServicee } from './assetsApi';

const initialState: IAssetsListState = {
    assetIsLoading: false,
    assetsAreLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchAssetCurrencies = createAsyncThunk(
    '/assets/tryToFetchAssetCurrencies',
    async () => {
        const result = await AssetsServicee.tryToFetchAssetCurrencies()
        return result?.data
    }
)

export const assetsSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

        .addCase(tryToFetchAssetCurrencies.pending, (state) => {
            state.assetsAreLoading = true;
        })
        .addCase(tryToFetchAssetCurrencies.rejected, (state) => {
            state.assetsAreLoading = false;
        })
        .addCase(tryToFetchAssetCurrencies.fulfilled, (state, action) => {
            state.assetsAreLoading = false;
            state.requestStatus = 'success';
            state.currencies = action.payload;
        });
    }

})

export default assetsSlice.reducer